import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../../apiServices/axios';
import Logo from '../../assets/longLogoBright.png';
import styles from '../Register/css/Register.module.css';

/**
 * Two-step flow: expired notice + "Send New Invitation Email", then success + "Back to Sign In".
 * Used by /register/:key and /validate-invite/:key when the invitation key is expired.
 */
const InviteExpiredCard = ({ invitationKey }) => {
    const navigate = useNavigate();
    const [inviteSent, setInviteSent] = useState(false);
    const [sendingInvite, setSendingInvite] = useState(false);

    const handleSubmit = async () => {
        if (sendingInvite) return;
        if (!invitationKey) {
            toast.error('Invitation key is missing');
            return;
        }
        setSendingInvite(true);
        try {
            const response = await axiosInstance.post(`accounts/invitations/request_reset_invitation/`, { key: invitationKey });
            if (response.status === 200) {
                setInviteSent(true);
            }
        } catch {
            toast.error('Failed to request new invitation');
        } finally {
            setSendingInvite(false);
        }
    };

    return (
        <div className={styles.body}>
            <div className={styles.dotedBg}>
                <div className={styles.formCard}>
                    <div className={styles.formHeader}>
                        <img src={Logo} width={73} alt="lens-logo" />
                    </div>
                    <div className={styles.formBody}>
                        {!inviteSent ? (
                            <>
                                <h5 className={styles.formLabel}>This Invitation Has Expired</h5>
                                <p className={styles.formSubtitle}>
                                    For security reasons, this invitation link is no longer active. Click below to receive a new invitation email and continue your setup.
                                </p>
                                <button onClick={handleSubmit} className={styles.submitBtn} disabled={sendingInvite}>
                                    {sendingInvite ? 'Sending...' : 'Send New Invitation Email'}
                                </button>
                            </>
                        ) : (
                            <>
                                <h5 className={styles.formLabel}>New Invitation Sent</h5>
                                <p className={styles.formSubtitle} style={{ marginBottom: '16px' }}>
                                    A new invitation email has been sent to your registered email address. Please check your inbox and use the latest email to continue.
                                    <br />
                                    <br />
                                    Didn&apos;t receive it? Check your spam or junk folder.
                                </p>

                                <button type="button" onClick={() => navigate('/login')} className={styles.submitBtn}>
                                    Back to Sign In
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <a href="https://www.iubenda.com/terms-and-conditions/15531073" target="_blank" rel="noreferrer">
                    Terms of Use
                </a>
                <a href="https://www.iubenda.com/privacy-policy/15531073/legal?ifr=true&height=650&newmarkup=yes&an=no" target="_blank" rel="noreferrer">
                    Privacy & Cookies
                </a>
            </div>
        </div>
    );
};

export default InviteExpiredCard;
